<template>
  <!-- 授权绑定 订购服务 重新授权的弹窗提示 -->
  <el-dialog
    :title="curTitle"
    :visible.sync="visible"
    width="710px"
    :close-on-click-modal="false"
  >
    <div class="y-f">
      <i class="el-icon-warning y-fs-18 y-fc-E6A23C y-mr-5"></i>
      <div>
        <div class="y-fs-16 y-fc-333 y-fw-700">确认是否{{ titleType === '1' ? '订购' : '授权' }}当前登录的店铺？</div>
        <div class="y-fs-14 y-mt-10">若出现店铺无法{{ titleType === '1' ? '订购' : '授权' }}，请按照以下步骤尝试解决：</div>
        <div class="y-mt-10 y-fs-14">
          1、点击打开<svg-icon class="icon" :iconClass="PLATFORMICONMAP[platFormCode]"></svg-icon>
          <a :href="linkMap[platFormCode]" target="_blank" class="y-fc-4C84FF y-a-none">{{ PLATFORMNAMEMAP[platFormCode] }}商家后台</a>
        </div>
        <div class="y-mt-10 y-fs-14">2、查看右上角店铺名称是否是需要{{ titleType === '1' ? '订购' : '授权' }}的店铺</div>
        <div class="y-mt-10 y-fs-14">3、若需要{{ titleType === '1' ? '订购' : '授权' }}新店铺，请先退出店铺后再进行{{ titleType === '1' ? '订购' : '授权' }}</div>
        <el-image 
          v-if="imgMap[platFormCode]"
          class="y-w-400 y-mt-10"
          :src="imgMap[platFormCode]" 
          :preview-src-list="[imgMap[platFormCode]]">
        </el-image>
      </div>
    </div>
    <el-checkbox class="y-mt-10" v-model="checked">下次不再提醒</el-checkbox>
    <div slot="footer" class="y-t-ac">
      <el-button type="primary" @click="handleConfirm">确认{{ titleType === '1' ? '订购' : '授权' }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { PLATFORMICONMAP, PLATFORMNAMEMAP } from '@/utils/globalConfig'
export default {
  props: ['showNote', 'titleType', 'platFormCode'],
  data() {
    return {
      PLATFORMICONMAP,
      PLATFORMNAMEMAP,
      imgMap: {
        PDD: require('../img/pdd.png'),
        PDDDF: require('../img/pdd.png'),
        PDDKJ: require('../img/pdd.png'),
        KS: require('../img/ks.png'),
        LUBAN: require('../img/douyin.png'),
        DYDF: require('../img/douyin.png'),
        TAOBAO: require('../img/tb.png'),
        ALI_1688: require('../img/1688.png'),
        JD: require('../img/jd.png'),
        WXSPH: this.titleType === '1' ? require('../img/wxsphdg.png') : require('../img/wxsphsq.png'),
        WXGYS: require('../img/wxsphsq.png'),
      },
      linkMap: {
        TAOBAO: 'https://loginmyseller.taobao.com',
        ALI_1688: 'https://login.taobao.com/?redirect_url=https%3A%2F%2Flogin.1688.com%2Fmember%2Fjump.htm%3Ftarget%3Dhttps%253A%252F%252Flogin.1688.com%252Fmember%252FmarketSigninJump.htm%253FDone%253Dhttps%25253A%25252F%25252Fmember.1688.com%25252Fmember%25252Foperations%25252Fmember_operations_jump_engine.htm%25253Ftracelog%25253Dlogin%252526operSceneId%25253Dafter_pass_from_taobao_new%252526defaultTarget%25253Dhttps%2525253A%2525252F%2525252Fwork.1688.com%2525252F%2525253Ftracelog%2525253Dlogin_target_is_blank_1688&style=tao_custom&from=1688web',
        PDD: 'https://mms.pinduoduo.com/login',
        PDDDF: 'https://mms.pinduoduo.com/login',
        PDDKJ: 'https://mms.pinduoduo.com/login',
        LUBAN: 'https://fxg.jinritemai.com/login',
        DYDF: 'https://fxg.jinritemai.com/login',
        KS: 'https://login.kwaixiaodian.com',
        JD: 'https://passport.shop.jd.com/login/index.action',
        XIAOHS: 'https://ark.xiaohongshu.com',
        WD: 'https://h5.weidian.com/m/signin',
        YZ: 'https://account.youzan.com/login',
        SN: 'https://mpassport.suning.com/ids/login',
        WXSPH: 'https://store.weixin.qq.com/shop/servicemarket/myServices?status=2',
        BLBL: 'https://shop.bilibili.com/#/db/home',
        WXGYS: 'https://store.weixin.qq.com/supplier/home?status=2',
      },
      checked: false,
      visible: true
    }
  },
  computed: {
    curTitle() {
      if(this.titleType === '1') {
        return '订购服务'
      }
      if(this.titleType === '2') {
        return '授权绑定'
      }
      if(this.titleType === '3') {
        return '重新授权'
      }
      return '';
    }
  },
  methods: {
    handleConfirm() {
      if(this.checked) {
        localStorage.setItem('authNoteDialog_' + this.titleType, 1);
      }
      // 确认按钮
      let type = this.platFormCode;
      if(this.titleType === '1') {
        // 订购服务
        this.$emit('subscriptionService', type);
      }
      if(this.titleType === '2' || this.titleType === '3') {
        // 授权操作
        this.$emit('authorizationBinding', type);
      }
      this.visible = false;
    }
  },
  watch: {
    visible(val) {
      this.$emit('update:showNote', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.icon {
  height: 20px !important;
  width: 20px !important;
  vertical-align: -5px !important;
}
/deep/ .el-checkbox__label {
  color: #333;
  font-weight: 700;
}
</style>
